export default __webpack_public_path__ + "static/media/613.929ac5d6.jpg";